export const getMetabaseUrl = (value?: string): string | undefined => {
    if (!value?.trim()) return undefined;

    try {
        const url = new URL(value.trim());
        if (!['https:', 'http:'].includes(url.protocol) || url.username || url.password) {
            return undefined;
        }
        return url.href;
    } catch {
        return undefined;
    }
};

export const METABASE_URL = getMetabaseUrl(process.env.REACT_APP_METABASE_URL);
